import React from 'react';

const SIngleNewsCard = ({news}) => {


  const {_id, title, thumbnail_url, image_url, author, rating, details } = news;
  // console.log(news);

  return (
    <div>
      {
      news?
      <div className='border-2 mb-10 rounded-lg'>
        <img src={image_url} alt="" />
        <div className='p-4'>
          <h2 className='text-xl font-semibold mt-3'>{title}</h2>
          <div className='flex items-center justify-between mt-3 font-medium'>
            <p className='text-lg'>{author.name? author.name : 'Not Found'}</p>
            <p>{author.published_date? author.published_date:'Not Found'}</p>
            <p>{rating.number}{rating.badge}</p>
          </div>
          <p className='mt-3'>{details.slice(0, 400)}</p>
        </div>
      </div>
      :
      <h2>No Data Found</h2>
      
    }
    </div>
  );
};

export default SIngleNewsCard;